import React, { FunctionComponent } from 'react';
import { Typography, Colors } from '@inplayer-org/inplayer-ui';
import styled from 'styled-components';

// types
import { AccessFee } from 'ducks/merchantDucks/items/types';
import { DefaultBrandingSet } from 'ducks/merchantDucks/branding/types';

// components
import BrandHeader from './PaywallElements/BrandHeader';
import Header from './PaywallElements/Header';
import Footer from './PaywallElements/Footer';
import PriceCard from './PaywallElements/PriceCard';
import {
  PaywallContainer,
  SectionContainer,
  FormContainer,
  ButtonHolder,
  Button,
  BackLink,
  FormContainerPadding,
} from './StyledElements';

const EmptyMessage = styled(Typography)`
  font-size: 0.9rem;
  text-align: center;
  margin: 0 0 1rem 0;
  color: ${Colors.gray};
`;

interface Props {
  accessFees: Array<AccessFee>;
  branding: DefaultBrandingSet;
}

const PriceOptionsScreen: FunctionComponent<Props> = ({ accessFees, branding }) => {
  const {
    paywall_secondary_color: paywallSecondaryColor,
    paywall_brand_logo: paywallBrandLogo,
    paywall_primary_color: paywallPrimaryColor,
    paywall_buttons_bg_color: paywallButtonsBgColor,
  } = branding;

  const renderPriceCards = () => {
    return accessFees.map(
      ({
        id,
        amount,
        currency,
        description,
        item: { item_type: { content_type: contentType = '' } = {} } = {},
        access_type: accessType,
        expires_at: expiresAt,
        current_phase: currentPhase,
      }) => {
        return (
          <PriceCard
            key={id}
            accessType={accessType}
            amount={amount}
            currency={currency}
            description={description}
            contentType={contentType}
            expiresAt={expiresAt}
            currentPhase={currentPhase}
          />
        );
      }
    );
  };

  return (
    <PaywallContainer>
      <BrandHeader backgroundColor={paywallSecondaryColor} brandLogo={paywallBrandLogo} />
      <Header title="CHOOSE YOUR PRICE" borderColor={paywallPrimaryColor}>
        {accessFees.length !== 0 ? (
          <FormContainerPadding>{renderPriceCards()}</FormContainerPadding>
        ) : (
          <EmptyMessage variant="p">There are no price options for this asset.</EmptyMessage>
        )}
      </Header>
      <SectionContainer>
        <FormContainer>
          <ButtonHolder>
            <BackLink>&lang; BACK</BackLink>
            <Button width="86%" buttonBgColor={paywallButtonsBgColor}>
              NEXT<i>&rarr;</i>
            </Button>
          </ButtonHolder>
        </FormContainer>
      </SectionContainer>
      <Footer backgroundColor={paywallPrimaryColor} />
    </PaywallContainer>
  );
};

export default PriceOptionsScreen;
